import React from 'react'

import { FlagProvider as UnleashFlagProvider } from '@unleash/proxy-client-react'

const REFRESH_INTERVAL_IN_SECONDS = 7200

const config = {
  url: process.env.REACT_APP_UNLEASH_PROXY_URL,
  clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY,
  refreshInterval: REFRESH_INTERVAL_IN_SECONDS,
  appName: 'telavita',
}

export function FlagProvider({ children }) {
  return (
    <UnleashFlagProvider config={config}>
      {children}
    </UnleashFlagProvider>
  )
}